import { useLocation, useNavigate } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import {ReactComponent as BackIcon} from "../Icons/arrow-left.svg";
import { Tools } from '../Services/Tools';
import ToolCard from './ToolCard';
import { getCategoryRoute, getCategoryToolRoute, getToolDisplayName } from './toolRoutes';
import { renderToolIcon } from '../Shared/toolIcons';


function Toolslayout() {
    const location = useLocation();
    const navigate = useNavigate();

    // Category metadata must also exist after direct navigation or a browser reload.
    const categorySlug = decodeURI(location.pathname).split('/').filter(Boolean).pop();
    const category = Tools.find(item => getCategoryRoute(item.CategoryName) === categorySlug);
    const { CategoryName: categoryName, SubCategory: tools = [], Icon: icon } = category || {};

    const handleToolClick = (tool) => {
        navigate(getCategoryToolRoute(tool.SubCategory))
    };

    return (
        <Col className="Alltools">

            {/* LEFT SIDEBAR */}
            <Row >
                <div>
                     <div className='AlltoolsHeading'>
                        <BackIcon className='headerIcons back-tool-button' onClick={()=>{navigate("/app/tools")}}/>
                            <div className='icon'>
                            <img src={icon} alt='' />
                            </div>
                            <span >{categoryName}</span>
                        </div>
                </div>

                 <div className='Alltoolslist'>
                            {tools.map((tool) => (
                                <ToolCard
                                    key={tool.SubCategory}
                                    icon={tool.Icon}
                                    iconElement={renderToolIcon(tool.SubCategory, 'tool-card-icon')}
                                    title={getToolDisplayName(tool.SubCategory)}
                                    meta={<div className="tool-description">{tool.Description}</div>}
                                    onClick={() => handleToolClick(tool)}
                                />
                            ))}
                        </div>
            </Row>
        </Col>
    );
}

export default Toolslayout;
